import React from "react";
import {
  BellRing,
  Download,
  Edit3,
  FileCheck2,
  History,
  Mail,
  Pause,
  Printer,
  ReceiptText,
  Share2,
  Upload,
} from "lucide-react";

const actionIcons = {
  Edit: Edit3,
  "Send Mail": Mail,
  "Download PDF": Download,
  Print: Printer,
  Share: Share2,
  Pause,
  Resume: BellRing,
  "Generate Invoice": ReceiptText,
  "View History": History,
  "Upload Receipt": Upload,
  "Convert to Invoice": FileCheck2,
  "Convert to Purchase": FileCheck2,
  "Convert to Sales Order": FileCheck2,
  "Convert to Delivery Challan": FileCheck2,
  "Apply to Invoice": FileCheck2,
};

const DocumentActionBar = ({ actions = [], onAction, pdfLoading }) => {
  if (!actions.length) return null;

  return (
    <div className="document-actions">
      {actions.map((action) => {
        const Icon = actionIcons[action] || FileCheck2;
        const isPdf = action === "Download PDF";
        return (
          <button key={action} onClick={() => onAction?.(action)} disabled={isPdf && pdfLoading}>
            <Icon size={16} />
            {isPdf && pdfLoading ? "Generating PDF..." : action}
          </button>
        );
      })}
    </div>
  );
};

export default DocumentActionBar;
